import React from "react";
import { observer } from "mobx-react-lite";
import { Button, Field, Stack, Input } from "@chakra-ui/react";
import { t } from "i18next";

import { useFormik } from "formik";
import { useStores } from "../../../shared/stores/RootStore";
import { CustomDialog } from "../../../shared/views/CustomDialog";
import { toast } from "../../../shared/views/CustomToaster";

const i18prefix = "account:Integrations";

interface Props {
  accountId: string | null;
  onClose: () => void;
}

const CreateApiClientModalBase: React.FC<Props> = ({ accountId, onClose }) => {
  const { accountStore } = useStores();


  const formik = useFormik({
    initialValues: {
      name: "",
    },

    onSubmit: async (values) => {
      accountStore
        .createApiClient({
          accountId,
          name: values.name,
          permissions: "",
          scopes: [],
        })
        .then(() => {
          toast("success", t(`${i18prefix}.toast.saveSuccess`));
          onClose();
        })
        .catch(() => {
          toast("error", t(`${i18prefix}.toast.saveFailed`));
        });
    },
  });

  const { name } = formik.values;
  const isNameDuplicated = !!accountStore.apiClients.find(
    (item) => item.name === name
  );

  return (
    <CustomDialog
      onClose={onClose}
      header={t(`${i18prefix}.createModal.create`)}
      footer={
        <Button
          disabled={!formik.values.name}
          flexShrink={0}
          colorPalette="primary"
          type="submit"
          form="createOrUpdateApiClient"
        >
          {t(`${i18prefix}.createModal.submit`)}
        </Button>
      }
    >
      <form id="createOrUpdateApiClient" onSubmit={formik.handleSubmit}>
        <Stack gap={4}>
          <Field.Root required invalid={isNameDuplicated}>
            <Field.Label>{t(`${i18prefix}.createModal.name`)}</Field.Label>
            <Input
              name="name"
              onChange={formik.handleChange}
              value={name}
              autoFocus
            />
            <Field.ErrorText>
              {t(`${i18prefix}.createModal.duplicatedName`)}
            </Field.ErrorText>
          </Field.Root>
        </Stack>
      </form>
    </CustomDialog>
  );
};

export const CreateApiClientModal = observer(CreateApiClientModalBase);
